import React from "react";
import { formatDuration } from "../../utils/formatDuration";
import { parseLocalDate } from "../../utils/dateUtils";

// parseLocalDate, not new Date(str) — a bare "YYYY-MM-DD" parses as UTC
// midnight and would render as the previous day west of UTC.
function formatDayHeading(dateStr) {
  const d = parseLocalDate(dateStr);
  if (!d) return dateStr;
  return d.toLocaleDateString("en-IN", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export default function DailyBreakdown({ days }) {
  if (!days?.length) {
    return <div className="uar-empty">No day-by-day activity in this period.</div>;
  }

  return (
    <div className="uar-daily">
      {days.map((day) => (
        <div key={day.date} className="uar-day">
          <div className="uar-day-head">
            <span className="uar-day-date">{formatDayHeading(day.date)}</span>
            <span className="uar-day-total">
              {formatDuration(day.totalMinutes)}
            </span>
          </div>

          <div className="uar-table-wrap">
            <table className="uar-table">
              <thead>
                <tr>
                  <th>Project</th>
                  <th>Stage</th>
                  <th>Tasks Submitted</th>
                  <th>Logged</th>
                </tr>
              </thead>
              <tbody>
                {day.entries.map((entry, idx) => (
                  <tr key={`${day.date}-${entry.projectName}-${entry.stageName}-${idx}`}>
                    <td className="uar-project-name">{entry.projectName}</td>
                    <td className="uar-stage-name">{entry.stageName}</td>
                    <td className="uar-muted">
                      {entry.taskTitles?.length
                        ? entry.taskTitles.join(", ")
                        : entry.additionalWorkMinutes > 0
                          ? null
                          : "—"}
                      {entry.additionalWorkMinutes > 0 && (
                        <div>
                          Additional work (
                          {formatDuration(entry.additionalWorkMinutes)}):{" "}
                          {entry.additionalWorkReasons.join("; ")}
                        </div>
                      )}
                    </td>
                    <td className="uar-hours">
                      {entry.minutes > 0 ? formatDuration(entry.minutes) : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}
